export default __webpack_public_path__ + "static/media/api.aa9d02ee.svg";